<script setup>
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';

const props = defineProps(['href', 'active']);

const classes = computed(() =>
    props.active
        ? 'flex flex-col items-center px-1 pt-1 text-xs font-medium leading-5 text-theme-600 focus:outline-hidden'
        : 'flex flex-col items-center px-1 pt-1 text-xs font-medium leading-5 text-gray-500 hover:text-gray-700 focus:outline-hidden focus:text-gray-700 focus:border-gray-300'
);
</script>

<template>
    <Link :href="href" :class="classes">
        <slot />
    </Link>
</template>
